import { NamedResponse } from 'src/app/shared/models/shared.model';

export class IMSProductBaseRequest {
  id: number = 0;
  name: string = '';
  description: string = '';
  sku: string = '';
  itemType: number = 1;
  status: number = 1;
  statusName: string = '';
  source: number = 3;
  companyId: number = 0;
  categoryId: number | null = null;
  unitId: number | null = null;
  brandId: number | null = null;
  height: number = 0;
  width: number = 0;
  length: number = 0;
  dimensionUnit: number = 0;
  weight: number = 0;
  weightUnit: number = 0;
  trackInventoryOption: number = TrackInventoryOption.Serial;
  productDepartmentId: number | null = null;
  supplierId: number | null = null;
  manufacturer: string = '';
  model: string = '';
  serialNumber: string = '';
  notes: string = '';
  warranty: string = '';
  warrantyDuration: string = '';
  defaultCost: number = 0;
  defaultSellingPrice: number = 0;
  discriminator: number = 1;
  disciminatorName: string = '';
  quantity: number = 0;
  attributes: ProductAttributeModel[] = [];
  internalStatus: number = 0;
  internalStatusName: string = '';
  isFragile: boolean = false;
  listerProduct = new listerProduct();
  productImages: ProductImageModel[] = [];
  createdAt: Date = new Date();
  warehouseId: number | null = null;
  warehouseLocationId: number | null = null;
  dimensionUnitName: string = '';
  weightUnitName: string = '';
}

export class ProductAttributeModel {
  name: any;
  value: any;
}
export class ProductAttribute {
  id: number = 0;
  name: string = '';
  description: string = '';
  isMandatory: boolean = false;
  productAttributeListItems: ProductAttributeListItem[] = [];
}

export class ProductAttributeListItem {
  productAttributeId: number = 0;
  value: string = '';
  id: number = 0;
}
export class ProductCategoryType {
  id: number = 0;
  name: string = '';
  description: string = '';
  companyId: number | null = null;
  productCategoryCount: number = 0;
  productCategoryTypeAttributes: ProductCategoryTypeAttribute[] | null = [];
}

export class ProductCategoryTypeAttribute {
  id: number = 0;
  productCategoryTypeId: number = 0;
  productAttributeId: number = 0;
  isMandatory: boolean = false;
}

export class listerProduct {
  postingDescription: string = '';
  supplyType: number | null = null;
  postingProfileId: number | null = null;
  defaultShipmentBoxId: number | null = null;
  listingStatus: number = 1;
  listingStatusName: string = '';
  condition: number = 0;
  conditionName: string = '';

  shipmentBox: NamedResponse | null = new NamedResponse();
  marketplaceAttributes: MarketplaceAttributeResponse[] = [];
}
export class CreateIMSproductRequest extends IMSProductBaseRequest {}
export class IMSproductResponse extends IMSProductBaseRequest {
  category: NamedResponse | null = new NamedResponse();
  brand: NamedResponse | null = new NamedResponse();
  supplier: NamedResponse | null = new NamedResponse();
  department: NamedResponse | null = new NamedResponse();
  warehouseLocation: NamedResponse | null = new NamedResponse();
}

export class PaginatedIMSproductsResponse {
  totalCount: number = 0;
  pageNumber: number = 1;
  pageSize: number = 15;
  items: IMSproductResponse[] = [];
}
export class ProductImageModel {
  id: number = 0;
  productId: number = 0;
  isPrimary: boolean = false;
  blobFileId: number = 0;
  url: string = '';
  imgFile: any;
}
export class ProductActionModel {
  isAdded: boolean = false;
  actionStatusText: string = '';
}

export class ProductPostingProfileRuleMappingModel {
  id: number = 0;
  productId: number = 0;
  postingProfileRuleId: number = 0;
  buyNowPrice: number = 0;
  reservePrice: number = 0;
  startingBid: number = 0;
  bidIncrement: number = 0;
  salesFloorPrice: number = 0;
  handlingCharges: number = 0;
}

export enum ProductInternalStatus {
  AIProcessing = 1,
  PendingImages = 2,
  Completed = 3,
  AIProcessFailed,
}
export enum ProductSupplyType {
  DonatedGoods = 1,
  Supplier = 2,
}

export enum ProductStatus {
  Draft = 1,
  Active,
  Inactive,
}

export enum ProductListingStatus {
  NotListed = 1,
  ReadyForListing,
  Queued,
  Processing,
  Failed,
  Listed,
  sold,
}

export enum TrackInventoryOption {
  Standard = 1,
  Batch = 2,
  Serial = 3,
}
export class MarketplaceAttributeResponse {
  name: string = '';
  value: string = '';
  values: string[] = [];
}
